/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-blog-archive"]';

/**
 * Friendation component
 */
export const blockBlogArchive = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handleFilter = () => {
      const filterButtons: HTMLButtonElement[] = Array.from(
        component.querySelectorAll('.filter button')
      );

      if (!filterButtons.length) return;

      const items: HTMLLIElement[] = Array.from(
        component.querySelectorAll('li.list-item')
      );

      const activateFilter = (x: HTMLButtonElement) => {
        x.setAttribute('aria-current', 'true');
        x.classList.add('button--primary');
        x.classList.remove('button--secondary');
      };

      const deActivateFilter = (x: HTMLButtonElement) => {
        x.setAttribute('aria-current', 'false');
        x.classList.remove('button--primary');
        x.classList.add('button--secondary');
      };

      filterButtons.forEach((filterButton) => {
        const onFilter = (e: MouseEvent) => {
          e.preventDefault();

          const filter = filterButton.dataset.filter;

          if (filter === '*') {
            // Reset filter buttons
            filterButtons
              .filter((x) => x.dataset.filter !== '*')
              .forEach((x) => {
                deActivateFilter(x);
              });
            filterButtons
              .filter((x) => x.dataset.filter === '*')
              .forEach((x) => {
                activateFilter(x);
              });
          } else {
            filterButtons.forEach((x) => {
              deActivateFilter(x);
            });

            activateFilter(filterButton);
          }

          items.forEach((item) => {
            item.inert =
              filter === '*' ? false : item.dataset.category !== filter;
          });
        };

        filterButton.addEventListener('click', onFilter);
      });
    };

    handleFilter();
  });
};
